import PropTypes from "prop-types";
import Image from "next/image";
import * as S from "./styled";
import {
  Text,
  Link,
  colors,
  getThemeWithMedia,
  DarkTheme,
} from "@a0/quantum-web";
import mediaSizes from "@hub/ui/auth0/shared/mediaSizes";
import { ThemeProvider } from "styled-components";

const LatestContent = ({ posts }) => (
  <ThemeProvider theme={getThemeWithMedia(DarkTheme, mediaSizes)}>
    <S.Wrapper>
      <S.Title>Our Latest Resources</S.Title>
      <S.PostsWrapper>
        <S.PostsContainer>
          {posts &&
            posts.map((post) => (
              <S.Post href={post.link} key={post.link} target="_blank">
                <S.PostImage>
                  <Image src={post.thumbnail} alt="" layout="fill" />
                </S.PostImage>
                <S.TextContainer>
                  <Link
                    size="small"
                    as="p"
                    styleOverrides={{
                      color: colors.neutral_n20,
                      margin: "0 0 1.2rem",
                    }}
                    href={post.link}
                  >
                    {post.title}
                  </Link>
                  <Text
                    type="Paragraph"
                    size="small"
                    styleOverrides={{
                      color: colors.neutral_n60,
                      margin: 0,
                    }}
                  >
                    {post.description}
                  </Text>
                </S.TextContainer>
              </S.Post>
            ))}
        </S.PostsContainer>
      </S.PostsWrapper>
    </S.Wrapper>
  </ThemeProvider>
);

LatestContent.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.shape()),
};

export default LatestContent;
